// extracted by mini-css-extract-plugin
module.exports = {"item":"item_item__3Y2XS","thumbnail":"item_thumbnail__1cWaR","data":"item_data__1-mIT","date":"item_date__1mmmQ"};